import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'eo-quantity-selector',
  templateUrl: './quantity-selector.component.html',
  styleUrls: ['./quantity-selector.component.scss'],
})
export class QuantitySelectorComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
